import StageCard from "../../ProgressStep/StageCard";
import styles from "./style.module.scss";
import AddIcon from "assets/icons/AddIcon";
import VLButton from "views/uikit/Buttons/VLButton";

interface AddClassCardProps {
  onClick: () => void;
}

export default function AddClassCard({ onClick }: AddClassCardProps) {
  return (
    <StageCard
      content={
        <div>
          <div className={styles.titleContainer}>
            <div className={styles.title}>Choose Labels</div>
            <div className={styles.subTitle}>
              Define the Initial Labels for Label Propagation
            </div>
          </div>
          <VLButton
            className={styles.addClassButton}
            type="primary"
            onClick={onClick}
          >
            <AddIcon />
          </VLButton>
        </div>
      }
    />
  );
}
